import { ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";

import { AssistantChatProvider } from "../../modules/assistant/context/AssistantChatContext";
import AuthGate from "../../routes/AuthGate";
import { store } from "../../store/store";
import theme from "../../theme";
import Snackbar from "./components/Snackbar";
import { RootRouter } from "./RootRouter";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <AssistantChatProvider>
          <RootRouter>
            <AuthGate />
          </RootRouter>
          <Snackbar />
        </AssistantChatProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
